<template>
  <div class="back-top" v-show="isShow" @click="backTop" title="返回顶部">
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    handleScroll() {
      this.isShow = window.pageYOffset >= 100
    },
    backTop() {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleScroll)
  }
}
</script>
<style>
.back-top {
  position: fixed;
  left: 50%;
  right: 100px;
  margin-left: 612px;
  bottom: 140px;
  cursor: pointer;
  width: 44px;
  height: 44px;
  background: url('../../../assets/img/icon/back_top_normal.png') no-repeat;
  background-size: cover;
}

.back-top:hover {
  background: url('../../../assets/img/icon/back_top_primary.png') no-repeat;
  background-size: cover;
}
</style>
